import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";

import getRecentActivity from "../../functions/getRecentActivity";
import { selectedEventIdState } from "../../recoil/events";
import { UserAccessTokenState } from "../../recoil/user";
import timeAgo from "../../utils/timeAgo";

import RecentActivityItem from "./RecentActivityItem";

import styles from "../../styles/events/RecentActivity.module.css";

export default function RecentActivity() {
  const accessToken = useRecoilValue(UserAccessTokenState);
  const selectedEvent = useRecoilValue(selectedEventIdState);
  const [activityData, setActivityData] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const resp = await getRecentActivity(
          accessToken,
          selectedEvent,
          10,
          "ticketScannedSuccessfully"
        );
        setActivityData(
          resp?.filter(
            (activity) => activity.payload.ticketType === "STAFFPASS"
          )
        );
      } catch (err) {
        console.log(err);
      }
    })();
  }, [selectedEvent]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>RECENT ACTIVITY</div>
      {activityData &&
        activityData.map((activity) => {
          return (
            <RecentActivityItem
              key={activity._id}
              timeAgo={new Date().toLocaleDateString()}
              name={activity?.payload?.buyerName}
              activity={activity?.payload?.activity}
              type={"scan"}
            />
          );
        })}
    </div>
  );
}
